var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.33,
    height: 79.729,
    viewBox: "0 0 61.33 79.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#36b6c1;opacity:0.4;}.b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-89 -137)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.548,3.375H14.416A7.666,7.666,0,0,0,6.75,11.041v64.4A7.666,7.666,0,0,0,14.416,83.1h46a7.666,7.666,0,0,0,7.666-7.666V27.907Zm-3.066,27.6V9.508L61.947,30.973Z",
    transform: "translate(82.25 133.625)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.5 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.5,4.5h21a3,3,0,0,1,3,3v21a3,3,0,0,1-3,3H7.5a3,3,0,0,1-3-3V7.5a3,3,0,0,1,3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15,12.75a2.25,2.25,0,1,1-2.25-2.25A2.25,2.25,0,0,1,15,12.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.5,22.5,24,15,7.5,31.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentImg2);
export default __webpack_public_path__ + "static/media/document-img-2.c849a36f0dfb9ab460ad191be3cb3361.svg";
export { ForwardRef as ReactComponent };